import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { AxiosHeaders, AxiosRequestConfig } from 'axios';

import { DefaultGetEventRequestArgs } from './includes/defaults';
import { GetEventSchema } from './includes/schema';
import { GetEventData, GetEventQueryPayload } from './includes/types';

interface CustomRequestHeaders extends AxiosHeaders {
  'x-api-endpoint': string;
}

/**
 * Query: GetEvent
 *
 * Retrieves a single event from the remote API via an authenticated GET request.
 * Validates the response data using a Zod schema.
 * Logs errors and rethrows them for upstream handling.
 */
export const GetEvent = async (
  payload: GetEventQueryPayload = ['Event', 'GetEvent', DefaultGetEventRequestArgs]
): Promise<GetEventData> => {
  try {
    const [theApiKey, theQueryKey, thePayload] = payload;

    const requestArgs: AxiosRequestConfig = {
      baseURL: config('API_URL'),
      headers: { 'x-api-endpoint': `/events/${thePayload?.eventId ?? ''}` } as CustomRequestHeaders,
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);
    return GetEventSchema.parse(remoteResponse.data);
  } catch (error) {
    logger.error('src/entities/Event/api/requests/queries/GetEvent/GetEvent.ts -> GetEvent()', false, error);
    throw error;
  }
};
